import { SaleOffer } from '../../api/SalesAPI';
import { formatOfferSummary } from '../../utils/saleLineItems';
import { INSTALMENT_SUM_EPS } from '../../utils/saleInstalmentSuggestions';

type Props = {
  offer: SaleOffer;
  currency: string;
  baseAmount: number;
  netAmount: number;
};

function formatAmount(amount: number, currency: string): string {
  return `${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
}

function SaleCollapsedOfferSummary({ offer, currency, baseAmount, netAmount }: Props) {
  const showOriginal = Math.abs(baseAmount - netAmount) >= INSTALMENT_SUM_EPS;

  return (
    <p className="text-xs text-gray-500">
      {formatOfferSummary(offer, currency, baseAmount)}
      {showOriginal && (
        <>
          <span className="mx-1">·</span>
          <span className="line-through">{formatAmount(baseAmount, currency)}</span>
        </>
      )}
      <span className="mx-1">·</span>
      <span className="font-semibold text-gray-900">{formatAmount(netAmount, currency)}</span>
    </p>
  );
}

export default SaleCollapsedOfferSummary;
